/* eslint-disable @typescript-eslint/no-explicit-any */
import { CouponType } from '@/constants'
import { useStore } from '@/containers'
import type { GiftItems, OtherOffers } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { type Dispatch, type SetStateAction } from 'react'

interface InformationType {
  setListGift: Dispatch<SetStateAction<GiftItems[] | undefined>>
  listGift: GiftItems[] | undefined
  setListOffer: Dispatch<SetStateAction<OtherOffers[] | undefined>>
  listOffer: OtherOffers[] | undefined
  login?: boolean
}
export const Gift = ({ listGift, listOffer }: InformationType) => {
  const { selectedLang } = useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }
  const giftReduce = listGift?.map(e => ({
    ...e,
    type: 'gift',
    order: e?.optionBuy ? 1 : 2,
  })) as any
  const offerReduce = listOffer?.map((e: any) => ({
    ...e,
    type: 'offer',
    order: e?.content?.featured ? 0 : 3,
  })) as any
  const arr: any[] = [...giftReduce, ...offerReduce]
  const dataGift = arr?.sort((a: any, b: any) => a?.order - b?.order)

  return (
    <div className='container w-full px-[6px] border-gray-200 pb-[6px]'>
      <div className='main-description break-words bg-white rounded-md pt-1 pb-2 px-2'>
        {dataGift &&
          dataGift?.map((e: any, i: number) => (
            <>
              {e.type == 'gift' ? (
                <div
                  className='form-check-default box-checkbox mt-2 flex'
                  key={i}
                >
                  <span className='mr-[10px] flex h-[20px] w-[20px] items-center justify-center self-center rounded-full bg-gray-1100 text-xs font-extrabold leading-3'>
                    {i + 1}
                  </span>
                  <div className='gap-x-2 w-full'>
                    <span className='text-sm text-dark-900'>Tặng </span>
                    <span
                      className={`text-sm text-dark-900 ${
                        e?.type == CouponType.COUPON ? '' : 'font-bold'
                      }`}
                    >
                      {getTranslate(e?.name)}
                    </span>
                    {e?.optionBuy
                      ? e?.displayPrice &&
                        e?.price > 0 && (
                          <span className='italic'>
                            <span> (Không lấy quà trừ </span>
                            <span className='text-sm font-bold text-primary-base'>
                              {e?.price
                                ?.toLocaleString(selectedLang as string, {
                                  style: 'currency',
                                  currency: currency(selectedLang as string),
                                })
                                .replace(/\s₫/g, 'đ')}
                              {') '}
                            </span>
                          </span>
                        )
                      : e?.displayPrice &&
                        e?.price > 0 && (
                          <span className='italic'>
                            <span> (trị giá </span>
                            <span className='text-sm font-bold text-primary-base'>
                              {e?.price
                                .toLocaleString(selectedLang as string, {
                                  style: 'currency',
                                  currency: currency(selectedLang as string),
                                })
                                .replace(/\s₫/g, 'đ')}
                              {') '}
                            </span>
                          </span>
                        )}
                    {e.viewMoreLink && (
                      <Link
                        href={e.viewMoreLink || '/'}
                        target='_blank'
                        className='ml-[5px] text-mainBody italic text-blue'
                      >
                        (Chi tiết)
                      </Link>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className='form-check-default flex box-checkbox mt-2'
                  key={i}
                >
                  <span className='mr-[10px] flex h-[20px] w-[20px] items-center justify-center self-center rounded-full bg-gray-1100 text-xs font-extrabold leading-3'>
                    {i + 1}
                  </span>
                  <div className='gap-x-2 w-full'>
                    <span
                      className={`text-sm text-dark-900 ${
                        e.content.featured ? 'font-bold' : ''
                      }`}
                    >
                      {getTranslate(e?.content?.name)}
                    </span>
                    {e.content?.viewMoreLink && (
                      <Link
                        href={e.content.viewMoreLink || '/'}
                        target='_blank'
                        className='ml-[5px] text-mainBody italic text-blue'
                      >
                        (Chi tiết)
                      </Link>
                    )}
                  </div>
                </div>
              )}
            </>
          ))}
      </div>
    </div>
  )
}

export default Gift
